import React from "react";
import "./css/StayInformed.css";

function StayInformed({ onBack }) {
  return (
    <div className="stay-informed">
      <div
        className="stay-informed-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1.5rem",
        }}
      >
        <h2>Stay Informed</h2>
        {onBack && (
          <button
            onClick={onBack}
            className="back-button"
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "0.95rem",
              fontWeight: "500",
              transition: "background-color 0.2s ease",
              marginLeft: "auto",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            ← Back to Home
          </button>
        )}
      </div>
      <p>Explore resources to stay safe and informed about cybersecurity:</p>
      <ul>
        <li>
          <a
            href="/docs/FraudAndLosses.png"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cybersecurity Basics (PDF)
          </a>
        </li>
        <li>
          <a
            href="https://www.ftc.gov"
            target="_blank"
            rel="noopener noreferrer"
          >
            Federal Trade Commission (FTC)
          </a>
        </li>
        <li>
          <a
            href="https://www.aarp.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            AARP Fraud Watch Network
          </a>
        </li>
        <li>
          <a
            href="/docs/TelltaleSigns.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Phishing Awareness Guide (PDF)
          </a>
        </li>
      </ul>
    </div>
  );
}

export default StayInformed;
